import { VDialog } from 'vuetify/lib/components/VDialog';
import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VDialog,
    {
      attrs: {
        "data-qa": "side-menu-drawer",
        transition: "fade-transition",
        fullscreen: "",
        "hide-overlay": "",
        attach: "",
        "content-class": "flex-dialog",
      },
      model: {
        value: _setup.isOpened,
        callback: function ($$v) {
          _setup.isOpened = $$v
        },
        expression: "isOpened",
      },
    },
    [
      _c(VOverlay, {
        attrs: { value: _setup.isOpened, "z-index": "0" },
        on: {
          click: function ($event) {
            _setup.isOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: "slide-x-transition",
            origin: "center center",
            appear: "",
          },
        },
        [
          _c(
            "aside",
            _vm._g(
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _setup.isOpened,
                    expression: "isOpened",
                  },
                ],
                staticClass:
                  "side-menu-drawer d-flex flex-column flex-grow-1 overflow-y-auto bg-gray-0 elevation-20 h-100 position-fixed",
                attrs: { "data-qa": "side-menu-drawer-panel" },
              },
              _setup.listeners
            ),
            [
              _c(
                "div",
                {
                  staticClass:
                    "side-menu-drawer__content d-flex flex-column flex-fill overflow-y-auto custom-scroll",
                  attrs: { "data-qa": "side-menu-drawer-content" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column flex-fill pa-4" },
                    [
                      _vm._t("default", null, {
                        counterXSpaceClass: "mx-n4",
                        counterYSpaceClass: "my-n4",
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }